import { Reveal } from "./Reveal";
import { LogoMark } from "./Logo";

export const Footer = ({ onBook }) => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 px-5 pb-10 pt-24 md:px-10">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <button data-testid="footer-book-btn" onClick={() => onBook()} className="group block text-left">
          <p className="text-xs uppercase tracking-[0.3em] text-[var(--gold)]">Pronta para perguntar?</p>
          <p className="font-display mt-4 text-[14vw] leading-[0.85] tracking-tighter text-[#F5F2EB] transition-colors duration-500 group-hover:text-[var(--gold)] md:text-[9rem]">
            Tire sua <em>carta.</em>
          </p>
        </button>
      </Reveal>
      <div className="mt-20 flex flex-col justify-between gap-6 border-t border-white/10 pt-8 text-sm text-white/60 md:flex-row md:items-center">
        <div className="flex items-center gap-3 text-[var(--gold)]">
          <LogoMark className="h-6 w-6" />
          <span className="text-white/70">© {new Date().getFullYear()} Mãos Arcana</span>
        </div>
        <a data-testid="footer-whatsapp-link" href="https://wa.me/5541988545280" target="_blank" rel="noreferrer" className="transition-colors duration-300 hover:text-[var(--gold)]">
          WhatsApp (41) 98854-5280
        </a>
        <p className="text-xs text-white/55">Tarot é uma ferramenta de autoconhecimento e não substitui orientação médica, jurídica ou financeira.</p>
      </div>
    </div>
  </footer>
);
